export enum EAccrualPolicyType {
  PTO = "pto",
  SICK_LEAVE = "sick_leave",
  CUSTOM = "custom",
}

export type TAccrualTypeAmounts = { [key in EAccrualPolicyType]: number };

export enum EAccrualPolicyStatus {
  LIVE = "live",
  PENDING = "pending",
  TERMINATED = "terminated",
}

export enum ERolloverType {
  FIXED = "fixed",
  WORK_ANNIVERSARY = "work_anniversary",
}
